import { useDispatch, useSelector } from 'react-redux';
import {
  postCrmEvent,
  postEventBuyButtonClicked,
  postEventBuyStep,
  postSfhJourneyStarted,
} from '../../store/actions/crmEvent/crmEventActions';
import { getCurrentAccountUid } from '../../store/selectors/accountSelectors';
import useSellFromHomeEligibility from '../hooks/useSellFromHomeEligibility';

export const useBuyButtonEvent = () => {
  const dispatch = useDispatch();

  return (buttonType, account, productCode) => {
    dispatch(
      postEventBuyButtonClicked({
        accountUid: account?.AccountUid,
        buttonType,
        productCode,
      }),
    );
  };
};

export const useBuyFlowStepNameEvent = () => {
  const dispatch = useDispatch();
  return (account, stepName, product, orderType) => {
    dispatch(
      postEventBuyStep({
        accountUid: account?.AccountUid,
        data: {
          StepName: stepName,
          ItemProductCode: product?.ProductCode,
          AccountType: account?.AccountType,
          OrderType: orderType,
        },
      }),
    );
  };
};

export const useCrmEvent = () => {
  const dispatch = useDispatch();
  return (account, eventType, additionalData = {}) => {
    const formattedData = Object.entries(additionalData).map(
      ([key, value]) => ({
        key,
        value: String(value),
      }),
    );

    dispatch(
      postCrmEvent({
        accountUid: account?.AccountUid,
        data: {
          EventType: eventType,
          Data: formattedData,
        },
      }),
    );
  };
};

// Dedicated SFH HubSpot event — hits its own endpoint (sfhjourneystarted),
// not the generic /crmevents type. Only fires when the user is allowed to
// start the SFH flow (not basic / restricted / IRA-UTMA / etc.). BE enriches
// user/account props from accountUid, so the FE only supplies it.
export const useSfhJourneyStartedEvent = () => {
  const dispatch = useDispatch();
  const accountUid = useSelector(getCurrentAccountUid);
  const { canStartSfhJourney } = useSellFromHomeEligibility();
  return () => {
    if (!canStartSfhJourney) return;
    dispatch(postSfhJourneyStarted({ accountUid }));
  };
};
